import { Link } from "react-router-dom";
import { Activity, ArrowLeft } from "lucide-react";

export default function LegalShell({ title, effective, children }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white/80 backdrop-blur sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Activity className="h-5 w-5 text-blue-900" strokeWidth={1.75} />
            <span className="font-heading text-lg font-extrabold tracking-tight text-slate-900">RIF Master</span>
          </Link>
          <Link to="/" className="text-sm text-slate-600 hover:text-slate-900 inline-flex items-center gap-1">
            <ArrowLeft className="h-4 w-4" strokeWidth={1.75} /> Back to home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-14">
        <div className="eyebrow">Legal</div>
        <h1 className="mt-1 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{title}</h1>
        <div className="mt-1 text-xs text-slate-500">Effective: {effective}</div>
        <article className="prose prose-slate mt-8 max-w-none [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-lg [&_h2]:font-bold [&_p]:text-slate-700 [&_p]:leading-relaxed [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_li]:text-slate-700 [&_a]:text-blue-900 [&_a]:font-semibold [&_strong]:text-slate-900">
          {children}
        </article>

        <div className="mt-14 border-t border-slate-200 pt-6 text-sm text-slate-500 flex flex-wrap gap-4">
          <Link to="/terms" className="hover:text-slate-900">Terms &amp; Conditions</Link>
          <Link to="/privacy" className="hover:text-slate-900">Privacy Policy</Link>
          <Link to="/refund" className="hover:text-slate-900">Refund &amp; Cancellation</Link>
          <Link to="/contact" className="hover:text-slate-900">Contact Us</Link>
        </div>
      </main>
    </div>
  );
}
